// extracted by mini-css-extract-plugin
export default {"container":"JsonInputUI_container__zN-09"};